var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../service/api.service';
import { ContentBaseService } from '../../../component/base/contentbase.service';
import { Option } from '../../../models/option/option';
import { ColumnBaseService } from '../base/columnbase.service';
var Select2ajaxService = /** @class */ (function (_super) {
    __extends(Select2ajaxService, _super);
    function Select2ajaxService(logger, api, service) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.service = service;
        _this.url = '/v1/type';
        _this.options = {};
        return _this;
    }
    Select2ajaxService.prototype.setInit = function (targetComponents) {
        var _this = this;
        if (targetComponents === void 0) { targetComponents = []; }
        if (targetComponents.length === 0) {
            this.options = {};
        }
        else {
            targetComponents.filter(function (comp) { return typeof _this.options[comp] !== 'undefined'; }).forEach(function (comp) { return _this.options[comp] = {}; });
        }
    };
    Select2ajaxService.prototype.getOption = function (compName, key) {
        return this.options[compName] && this.options[compName][key] ? this.options[compName][key] : new Option();
    };
    Select2ajaxService.prototype.setOption = function (compName, key, option) {
        if (typeof this.options[compName] === 'undefined') {
            this.options[compName] = {};
        }
        this.options[compName][key] = option;
    };
    Select2ajaxService.prototype.getUrl = function () {
        return this.url;
    };
    Select2ajaxService.prototype.getOptionFromCode = function (dataType, code) {
        this.baseUrl = this.url + '?name=' + dataType;
        if (typeof code === 'undefined' || code === null) {
            code = '';
        }
        return _super.prototype.getRecord.call(this).pipe(map(function (recs) {
            var option;
            for (var _i = 0, recs_1 = recs; _i < recs_1.length; _i++) {
                var rec = recs_1[_i];
                if (rec.code === code.toString()) {
                    option = rec;
                    break;
                }
            }
            return option;
        }));
    };
    Select2ajaxService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    Select2ajaxService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService },
        { type: ColumnBaseService }
    ]; };
    return Select2ajaxService;
}(ContentBaseService));
export { Select2ajaxService };
//# sourceMappingURL=select2ajax.service.js.map